<template>
  <v-slide-y-transition mode="out-in">
    <v-container fluid fill-height>
      <v-layout column>
        <div>
          <TagFilter ref="sd" @text="newV => (filterText = newV)" target="lib" :targetList="this.selectedTab" />
        </div>
        <v-flex xs12 scrollable>
          <v-list class="vlist pt-0 pb-0 lib" two-line>
            <virtual-scroller class="scroller" :items="items" item-height="75">
              <template slot-scope="props">
                <v-list-tile @click.native="edit(props.item)" :avatar="!mobileMenu" :item="props.item" :key="props.item._id">
                  <v-list-tile-avatar v-if="!mobileMenu">
                    <img :src="imgUrl(props.item.img)" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ getDescr(props.item) }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ getLevelDescr(props.item) }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action
                    :class="{
                      large: selectedTab == 'prod' && !mobileMenu,
                      huge: selectedTab == 'var' && !mobileMenu
                    }"
                  >
                    <v-btn
                      round
                      flat
                      class="price"
                      :disabled="keepSync"
                      v-if="selectedTab == 'prod' && !mobileMenu"
                      @click.native.stop="editMainPrice(props.item)"
                      :class="{ noListino: noListino(props.item) }"
                    >
                      <v-icon>{{ getPriceType(props.item) == 1 ? 'euro_symbol' : 'fa-percent' }}</v-icon
                      >&nbsp;
                      <span class="green--text">{{ getPrice(props.item) }}</span>
                    </v-btn>
                    <v-btn
                      round
                      flat
                      class="price"
                      :disabled="keepSync"
                      v-if="selectedTab == 'var' && !mobileMenu"
                      @click.native.stop="editMainPrice(props.item)"
                      :class="{ noListino: noListino(props.item) }"
                    >
                      <v-icon>{{ getPriceType(props.item, 'var', true) == 1 ? 'euro_symbol' : 'fa-percent' }}</v-icon
                      >&nbsp; <span class="green--text">{{ getPrice(props.item, 'var') }}</span> /
                      <span class="red--text">{{ getPrice(props.item, 'var', true) }}</span>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-action>
                    <v-btn icon @click.native="edit(props.item)">
                      <v-icon class="orange--text ">mode_edit</v-icon>
                    </v-btn>
                    <v-btn v-if="!keepSync" icon @click.native.stop="remove(props.item)">
                      <v-icon class="orange--text ">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </virtual-scroller>
          </v-list>
        </v-flex>
        <div>
          <v-bottom-nav ref="bottomNav" :active.sync="selectedTab" absolute :value="true" class="transparent listFilter">
            <v-btn flat light class="green--text" value="prod">
              <span>Prodotti</span>
              <v-icon>shopping_cart</v-icon>
            </v-btn>
            <v-btn flat light class="green--text" value="var">
              <span>Varianti</span>
              <v-icon>playlist_add</v-icon>
            </v-btn>
            <v-btn flat light class="green--text" value="ingr">
              <span>Ingredienti</span>
              <v-icon>playlist_add</v-icon>
            </v-btn>
            <span class="btnSeparator"></span>
            <v-btn flat light class="green--text" value="group">
              <span>Gruppi</span>
              <v-icon>group_work</v-icon>
            </v-btn>
          </v-bottom-nav>
        </div>
      </v-layout>
      <MainPriceChanger @close="saveMainPrice" :listino="currentListino" :editing="editingP" :type="selectedTab" />
      <ConfirmDelete @close="removeCallback" :target="target" :confirm="confirmDelete" :message="delMsg" />
    </v-container>
  </v-slide-y-transition>
</template>

<script>
/**
 * Libreria di prodotti / varianti / ingredienti e gruppi
 * @module components/lib/Lib
 */
import breakpoint from '@/breakpoints.js'
import TagFilter from '@/components/common/TagFilter.vue'
export default {
  name: 'lib',
  data() {
    return {
      dialog: false,
      currentProd: null,
      filterText: '',
      editingP: null,
      show: true,
      confirmDelete: null,
      target: null,
      selectedTab: 'prod',
      delMsg: "L'elemento verrà eliminato. Le voci di menù che lo utilizzavano verranno a loro volta eliminate."
    }
  },
  mixins: [breakpoint],
  components: { TagFilter },
  methods: {
    saveMainPrice(price) {
      if (price) {
        let updateObj = utils.clone(this.editingP)
        this.$store.dispatch('UPDATEPVI', {
          pvi: utils.setMainPrezzo(updateObj, this.currentListino, this.selectedTab, price),
          img: null,
          callback: () => this.$forceUpdate()
        })
      }
      this.editingP = null
    },
    editMainPrice(content) {
      this.editingP = content
    },
    getDescr(item) {
      return utils.getMainDesc(item)
    },
    getLevelDescr(item) {
      return utils.getLevelDescr(item)
    },
    imgUrl(item) {
      return utils.getImgUrl(item, 40, 40, true)
    },
    noListino(content) {
      return !utils.getMainPrezzo(content, this.currentListino, this.selectedTab).daListino
    },
    edit(item) {
      this.$router.push({ name: 'editTapi', params: { prod: utils.clone(item) } })
    },
    addNew() {
      let newObj = new utils.prodTpl('', this.currentListino)

      if (this.selectedTab == 'prod') return this.$router.push({ name: 'editTapi', params: { prod: newObj.newProdVarIngr() } })

      if (this.selectedTab == 'var') return this.$router.push({ name: 'editTapi', params: { prod: newObj.newVariante() } })

      if (this.selectedTab == 'ingr') return this.$router.push({ name: 'editTapi', params: { prod: newObj.newIngrediente() } })

      if (this.selectedTab == 'group')
        return this.$router.push({
          name: 'editTapi',
          params: { prod: new utils.tagTpl('', this.currentListino).newTag() }
        })
    },
    getPrice(content, specific = null, togli = false) {
      return utils.toNumeral(utils.getMainPrezzo(content, this.currentListino, specific, togli).prezzo).toShow()
    },
    getPriceType(content, specific = null, togli = false) {
      return utils.getMainPrezzo(content, this.currentListino, specific, togli).tipo
    },
    remove(pvi) {
      this.confirmDelete = true
      this.target = pvi
    },
    removeCallback(result) {
      if (result) {
        let updateObj = Object.assign({}, this.target, { _id: `DEL-${this.target._id}` })
        if (this.target.tipo != 'tag') {
          this.$store.dispatch('UPDATEPVI', { pvi: updateObj, img: null, callback: () => this.$forceUpdate() })
        } else {
          this.$store.dispatch('UPDATETAG', { tag: updateObj, img: null, callback: () => this.$forceUpdate() })
        }
      }

      this.target = null
      this.confirmDelete = null
    }
  },
  beforeMount() {
    let actions = []

    if (!this.$store.getters.User.keepSync) {
      actions.push({
        icon: 'library_add',
        text: 'Nuovo',
        callback: () => {
          this.addNew()
        }
      })
    }

    this.$store.dispatch('TOOLBAR_ACTIONS', actions)

    this.selectedTab = this.$store.state.libSelectedTab
  },
  computed: {
    items() {
      let response = this.$store.getters.filteredPvi(this.filterText, 'lib')
      return response
    },
    currentListino() {
      return this.$store.getters.currentListino
    },
    mobileMenu() {
      return this.$breakpoint.xs || this.$breakpoint.sm
    },
    keepSync() {
      return this.$store.getters.User.keepSync
    }
  },
  watch: {
    selectedTab: function(tabname) {
      // update filter
      this.$store.dispatch('LIBSELECTEDTAB', tabname)
    }
  }
}
</script>

<style lang="stylus" scoped>
.vlist
  width: 100%
  height: 100%
.listFilter
  position: relative
.noMargin
  margin-bottom: 0
.btnSeparator
  width 5px
  height 100%
  left 0
  background #212121
</style>



// WEBPACK FOOTER //
// src/components/lib/Lib.vue